import { Box, Grid, IconProps, Typography } from "@mui/material";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity } from "@websential/cosmic-v20";
import React, { FC, SVGProps, useRef, useState } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import { convertFileToBase64 } from "../../../common/Common";

const publicUrl = import.meta.env.BASE_URL ?? "/";
export interface IImportPayrollDataPanel {
    isSubmitting: boolean;
    isLoadingExportFile: boolean;
    onImportDataClickedHandler: (tag: string, file: string | null) => void,
    onExportButtonClick: (tag: string) => void,
}

export const SpreadsheetIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        {/* Back sheet */}
        <path
            d="M9 4h9.5A1.5 1.5 0 0 1 20 5.5v13A1.5 1.5 0 0 1 18.5 20H9"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Spreadsheet grid */}
        <path
            d="M12 8h6M12 11h6M12 14h6M12 17h6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />

        {/* Front sheet */}
        <path
            d="M4 6l8-2.2v16.4L4 18V6Z"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* X */}
        <path
            d="M6.2 8.5l3.6 7M9.8 8.5l-3.6 7"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);

interface IImportDataPanelInstructions {
    title: string;
    tag: string;
    instructions: string[];
}

let importDataPanelInstructions: IImportDataPanelInstructions[] = [
    {
        title: "Import in Payroll Data Panel",
        tag: "import_payroll",
        instructions: [
            "Click excel icon to download file.",
            "Enter payroll data.",
            "Save the excel file as tab delimited text file.",
            "Upload tab delimited text file to import data.",
        ]
    },
    {
        title: "Import Deduction Data",
        tag: "import_deduction",
        instructions: [
            "Click excel icon to download file.",
            "Enter deductions data.",
            "Save the excel file as tab delimited text file.",
            "Upload tab delimited text file to import data.",
        ]
    },
    {
        title: "Import Payroll and Deduction Data",
        tag: "import_both",
        instructions: [
            "Click excel icon to download file.",
            "Enter deductions  data.",
            "Save the excel file as tab delimited text file.",
            "Upload tab delimited text file to import data.",
        ]
    }
]
export const ImportPayrollDataPanel: FC<IImportPayrollDataPanel> = ({
    isSubmitting,
    isLoadingExportFile,
    onImportDataClickedHandler,
    onExportButtonClick,
}) => {

    const [selectedPayrollFile, setSelectedPayrollFile] = useState<any>(null);
    const [selectedDeductionFile, setSelectedDeductionFile] = useState<any>(null);
    const [selectedPayrollAndDeductionFile, setSelectedPayrollAndDeductionFile] = useState<any>(null);
    const [activeExportTag, setActiveExportTag] = useState<string | null>(null);
    const [activeSubmitTag, setActiveSubmitTag] = useState<string | null>(null);
    const fileInputRefs = useRef<Record<string, HTMLInputElement | null>>({});

    const getSelectedFile = (tag: string) => {
        if (tag === "import_payroll") return selectedPayrollFile;
        if (tag === "import_deduction") return selectedDeductionFile;
        if (tag === "import_both") return selectedPayrollAndDeductionFile;
        return null
    };

    const handleFileChange = async (event: any, tag: string) => {
        const file = event.target.files[0];
        if (!file) return;

        const base64 = await convertFileToBase64(file);
        const cleanBase64 = base64.split(",")[1];

        if (tag === 'import_payroll') {
            setSelectedPayrollFile(file);

        } else if (tag === 'import_deduction') {
            setSelectedDeductionFile(file);
        } else {
            setSelectedPayrollAndDeductionFile(file);
        }
    };

    const handleExportClick = (tag: string) => {
        setActiveExportTag(tag);
        onExportButtonClick(tag);
    };

    const handleImportClick = (tag: string) => {
        setActiveSubmitTag(tag);
        onImportDataClickedHandler(tag, getSelectedFile(tag));
    };
    return (
        <>
            <Grid container spacing={0.8} >

                {/* {isSubmitting || isLoadingExportFile ? (
                    <CircularProgress
                        sx={{
                            width: "20px!important",
                            height: "20px!important",
                            "& .MuiCircularProgress-svg": { width: "20px", height: "20px" },
                        }}
                    />
                ) : (<></>)} */}
                {importDataPanelInstructions.map((item: any) => {
                    const isThisExporting = isLoadingExportFile && activeExportTag === item.tag;
                    const isThisSubmitting = isSubmitting && activeSubmitTag === item.tag;
                    const selectedFile = getSelectedFile(item.tag);
                    return (
                        <Grid container>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontSize: "1rem",
                                        fontWeight: 700,
                                        color: "#000000",
                                        mb: 2,
                                        mt: 6
                                    }}
                                >
                                    {item.title}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                {/* <Box
                                    component="i"
                                    className="pi pi-file-excel"
                                    onClick={() => onExportButtonClick(item.tag)}
                                    sx={{
                                        fontSize: "2.25rem",
                                        color: "#000000",
                                        display: "block",
                                        pl: 2.5,
                                        cursor: "pointer"
                                    }}
                                /> */}
                                {/* <img
                                src={`${process.env.PUBLIC_URL}/images/left-bottom-img.jpg`}
                                alt="..."
                                width="100%"
                            /> */}
                                <Box
                                    onClick={() => !isLoadingExportFile && handleExportClick(item.tag)}
                                    role="button"
                                    aria-label={`Download ${item.title} template`}
                                    aria-busy={isThisExporting}
                                    sx={{
                                        position: "relative",
                                        width: 64,
                                        height: 64,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: 2,
                                        // backgroundColor: "#F2F7F2",
                                        cursor: isLoadingExportFile ? "default" : "pointer",
                                        transition: "background-color .2s ease, transform .15s ease",
                                        "&:hover": {
                                            // backgroundColor: isLoadingExportFile ? "#F2F7F2" : "#E6F2E6",
                                            transform: isLoadingExportFile ? "none" : "translateY(-1px)",
                                        },
                                    }}
                                >
                                    <Box
                                        component={SpreadsheetIcon}
                                        // src={<SpreadsheetIcon/>}
                                        // alt="Download Excel template"
                                        aria-hidden
                                        sx={{
                                            width: 34,
                                            height: 34,
                                            objectFit: "contain",
                                            opacity: isThisExporting ? 0.25 : 1,
                                            transition: "opacity .2s ease",
                                        }}
                                        onError={(e: any) => {
                                            // Fallback to icon font if the image asset isn't present yet
                                            e.target.style.display = "none";
                                            const sibling = e.target.nextSibling;
                                            if (sibling) sibling.style.display = "block";
                                        }}
                                    />
                                    <Box
                                        component="i"
                                        className="pi pi-file-excel"
                                        sx={{
                                            display: "none",
                                            fontSize: "1.9rem",
                                            // color: "#1D6F42",
                                            opacity: isThisExporting ? 0.25 : 1,
                                            transition: "opacity .2s ease",
                                        }}
                                    />
                                    {isThisExporting && (
                                        <CircularProgress
                                            size={26}
                                            thickness={4}
                                            sx={{
                                                position: "absolute",
                                                color: "#1D6F42",
                                            }}
                                        />
                                    )}
                                </Box>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <Box
                                    component="ul"
                                    sx={{
                                        m: 0,
                                        pl: 5,
                                        "& li": {
                                            fontSize: ".875rem",
                                            color: "#555",
                                            lineHeight: 1.5,
                                        },
                                    }}
                                >
                                    {item.instructions.map((item: any, index: any) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </Box>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 2.5, mb: item.tag === 'import_both' ? 6 : 0 }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontSize: "1rem",
                                        fontWeight: 700,
                                        color: "#000000",
                                        mb: 1
                                    }}
                                >
                                    Upload
                                </Typography>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        paddingX: "1.5rem"

                                    }}
                                >
                                    <input
                                        accept=".xlsx, .xls"
                                        type="file"
                                        onChange={(e: any) => handleFileChange(e, item.tag)}
                                        style={{ color: "rgba(0,0,0,.6)", width: "220px" }}
                                    />
                                    <EnhancedButtonPrimeReact
                                        label="Import Data"
                                        raised
                                        // severity={EnhancedButtonPrimeReactSeverity.Secondary}
                                        // onClickHandler={() => onImportDataClickedHandler(item.tag,
                                        //     item.tag === 'import_payroll' ? selectedPayrollFile :
                                        //         item.tag === 'import_deduction' ? selectedDeductionFile :
                                        //             selectedPayrollAndDeductionFile
                                        // )}
                                        severity={EnhancedButtonPrimeReactSeverity.Secondary}
                                        loading={isThisSubmitting}
                                        disabled={!selectedFile || isSubmitting}
                                        onClickHandler={() => handleImportClick(item.tag)}
                                    />
                                </Box>
                            </Grid>
                        </Grid>);
                })}


            </Grid>
        </>
    )
};

export default ImportPayrollDataPanel;

